import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SquareButton from '../../components/squareButton/squareButton';
import { useSaveSessionProfileMutation, useSaveExistingSessionProfileMutation } from '../../redux/services/tanProfilesApi';
import { useSetSessionMutation, useModifyComponentsMutation } from '../../redux/services/sessionApi';

const SessionStarted = () => {
    const { t } = useTranslation("translation", { keyPrefix: "sessionStarted" });
    const navigate = useNavigate();
    const session = useSelector((state) => state?.session);
    const [saveSessionProfile, { isLoading, isSuccess, isError }] = useSaveSessionProfileMutation();
    const [setSession, { isLoading: settingSession, isSuccess: sessionSetSuccess, isError: sessionSetError }] = useSetSessionMutation();
    const [modifyComponents, { isSuccess: modifiedComps, data: compData }] = useModifyComponentsMutation();

    const handleSaveProfile = async () => {
        // try {
        //     console.log(data)
        //     let newArray = tanProfile?.selectedProfile?.session_component.map(item => ({ ...item, value: parseInt(item.value) || 1, session_id: data?.payload?.id }))
        //     await modifyComponents(newArray).unwrap()
        //     navigate('/')
        // } catch (err) {
        //     console.log(err)
        // }
    };

    return (
        <Container className="text-center mt-5">
            <Row className="justify-content-center">
                <Col md={8}>
                    <h1 className="mb-4">{t("congratulations", "Congratulations!")}</h1>
                    <p className="mb-5">{t("paymentSuccess", "Your payment was successful, and your session has been started.")}</p>

                    <div className="d-flex justify-content-center gap-3">
                        <SquareButton onClick={() => navigate('/')}>
                            {t("goHome", "Home")}
                        </SquareButton>

                        {/* <SquareButton onClick={handleSaveProfile}>
                            {t("saveSessionProfile", "Save Session Profile")}
                        </SquareButton> */}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default SessionStarted;
